import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { PolicyFilters, PolicyListRequest } from 'types'

import { policyCount, policyGet, policyList } from './policy.service'

export const policyKeyFactory = {
  base: () => ['policies'],
  list: (request?: PolicyListRequest) => [
    ...policyKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  count: (filters?: PolicyFilters) => [
    ...policyKeyFactory.base(),
    'count',
    ...(filters ? [filters] : []),
  ],
  get: (policyUuid?: string) => [
    ...policyKeyFactory.base(),
    ...(policyUuid ? [policyUuid] : []),
  ],
}

export const queryPolicyList = (request: PolicyListRequest) =>
  queryOptions({
    queryKey: policyKeyFactory.list(request),
    queryFn: () => policyList(request),
    placeholderData: keepPreviousData,
  })

export const queryPolicyCount = (filters?: PolicyFilters) =>
  queryOptions({
    queryKey: policyKeyFactory.count(filters),
    queryFn: () => policyCount(filters),
    placeholderData: keepPreviousData,
  })

export const queryPolicyGet = (policyUuid: string) =>
  queryOptions({
    queryKey: policyKeyFactory.get(policyUuid),
    queryFn: () => policyGet(policyUuid),
  })
